/**
 * Downloads a file by opening it in a new tab
 * Browsers will typically download files that can't be displayed inline
 * @param url - The URL of the file to download
 */
export function downloadFile(url: string | undefined): void {
    if (!url) {
        console.warn('Attempted to open undefined URL in new tab');
        return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
}